



























































































































import {Prop} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';

import storeDevis from '@/stores/modules/devis';

import CrudList from '@/components/Crud/List.vue';
import TableHead from '@/components/Paginate/TableHead.vue';
import Checked from '@/components/Checked.vue';
import TableCell from '@/components/Paginate/TableCell.vue';
import {
	DxColumn,
	DxDataGrid,
	DxEditing,
	DxFilterRow,
	DxGrouping,
	DxGroupItem,
	DxGroupPanel,
	DxHeaderFilter,
	DxLookup,
	DxMasterDetail, DxPager, DxPaging,
	DxRangeRule,
	DxRequiredRule,
	DxScrolling,
	DxStringLengthRule,
	DxSummary,
	DxTotalItem, DxValueFormat
} from "devextreme-vue/data-grid";
import {DxCheckBox} from "devextreme-vue/check-box";
import {Devis, Token} from "@/models";
import {createStore} from "devextreme-aspnet-data-nojquery";
import {Stored} from "vue-stored-prop-decorator";
import storeToken from "@/stores/modules/token";
import CrudDeleteDialog from "@/components/Crud/DeleteDialog.vue";
import CrudDevisEditDialog from "@/components/Crud/Devis/EditDialog.vue";

@Component({
	components: {
		CrudList, TableHead, TableCell,
		DxDataGrid, DxColumn, DxEditing,
		DxFilterRow, DxHeaderFilter, DxGroupPanel,
		DxGrouping, DxScrolling, DxSummary,
		DxLookup, DxTotalItem, DxGroupItem,
		DxMasterDetail, DxStringLengthRule, DxRangeRule,
		DxRequiredRule, DxValueFormat, DxPaging,
		DxPager, DxCheckBox, Checked,
		CrudDeleteDialog, CrudDevisEditDialog
	}
})
export default class CrudDevisList extends Vue {

	@Prop({type: Boolean, default: true  }) private paginate;
	@Prop({type: Boolean, default: false }) private dense;
	@Stored(() => storeToken) token!: Token;

	private storeDevis = storeDevis;

	private url = process.env.VUE_APP_BACK_BASE_URL + '/api/devis'

	private editDevis: Devis = null;
	private deletedDevis: Devis = null;
	private dataGrid;

	private dataSource = createStore({
		key: 'id',
		loadUrl: `${this.url}/dxDataGrid`,
		onBeforeSend: (method, ajaxOptions) => {
			ajaxOptions.xhrFields = { withCredentials: true };
			ajaxOptions.headers = {
				'Authorization': 'BEARER ' + this.token.id
			}
		},
	});

	public refresh() {
		this.dataGrid = this.$refs['dataGridRefKey'] as DxDataGrid
		this.dataGrid.instance.refresh()
	}

	private calculateCellValue(data) {
		let date = data.date
		if (date === null) { return }
		let year = date.substr(0,4)
		let month = date.substr(5,2)
		let day = date.substr(8,2)
		return day + '/' + month + '/' + year
	}
}
